import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import ReactDOM from 'react-dom'
import { StickyContainer, Sticky } from 'react-sticky'
import { Pagination } from '@webmotors/buyer-design-system'
import { fetchSearchResult } from 'ducks/searchResult'
import { fetchCategories } from 'ducks/categories'
import { fetchDealerInfo } from 'ducks/dealerInfo'
import { fetchAutoCompleteCar } from 'ducks/autoCompleteCar'
import { fetchAutoCompleteBike } from 'ducks/autoCompleteBike'
import { fetchPhonesDetail } from 'ducks/phonesDetail'
import { fetchProposal } from 'ducks/proposal'
import { fetchBestSellers } from 'ducks/bestSellers'
import { fetchHotDeal } from 'ducks/hotDeal'
import { fetchDeclareSeo } from 'ducks/declareSeo'
import { config } from 'config/config'
import { customMakeModels } from 'config/config.customMakeModels'
import {
  VEHICLE_TYPE,
  COOKIES,
  TYPE_RESULT_LIST,
  MESSAGE_LEAD,
  SELLERSHIELD,
  ORIGIN_PAGES,
  TEXT,
  COOKIE_NOTICE_TYPES,
  FAIR,
} from '@/utils/constants'
import {
  getCookie,
  setCookie,
  clearCookie,
  createUrlAd,
  parseSearchFilters,
  getTypeVehicle,
  getItemFormattedLocation,
  getTypeAd,
  getItemPosition,
  getFilterSelected,
  sendDispatchEvent,
  insertQueryParameter,
  getQueryParameter,
  removeQueryParameter,
  generateLocationState,
  imageExists,
  getCookieLocation,
  getCookieLocationLeft,
  getCookieLocationRight,
  returnStateLong,
  cleanString,
  getItemUrlOrigin,
  onClientSide,
  setEventToLazyDispatch,
  hasLocationInUrl,
  hasNewCardLayout,
  parseLocationObj,
  removeAccents,
  checkStateIsAllowedList,
  getVehicleFilterCookie,
  handlePaginationABCTest,
} from '@/utils/utils'
import { createResponsiveBreakpoints } from 'utils/slick'
import {
  cookieCategoryIsActive,
  getEncryptedCookie,
} from '@/modern/utils/cookies'
import { getFBCLIDFromUrl, getGCLIDFromUrl } from '@/modern/hooks/useTargetApi/getVisitorData'
import { getTag } from 'seo/generateSeo'

import { withCookieNotice } from '@/store/context/cookie-notice-context'

import Main from 'components/Main'
// import Page from '@/modern/components/Page';
import Page from 'components/Page'
import WhiteBox from 'components/WhiteBox'
import WhiteBoxTestAbCard from 'components/WhiteBoxTestAbCard'
import BestSeller from 'components/BestSeller'
import PlaceHolder from 'components/PlaceHolder'
import Categories from 'container/Home/components/Categories'
import RecommendedVehicles from 'components/RecommendedVehicles'
import CardVehiclePlaceholder from 'components/CardVehicle/CardVehiclePlaceholder'
import CardVehicleListPlaceholder from 'components/CardVehicle/CardVehicleListPlaceholder'
import FilterResult from 'components/FilterResult'
import FoundCars from 'components/FoundCars'
import Button from 'components/Button'
import Filters from 'components/Filters'
import NotFound from 'container/NotFound'
import Media from 'components/Media'
import BreadCrumb from '@/modern/components/BreadCrumb'
import VehicleCardFactory from '@/modern/components/VehicleCardFactory'
import VehicleCardFactoryTestABCard from '@/modern/components/VehicleCardFactoryTestABCard'
import VehicleCardNewCar from '@/modern/components/VehicleCardNewCar'
import {
  Grid,
  GridItem,
} from '@/modern/pages/Favorites/Filled/FavoritesList/style'
import AdPlacement from 'components/AdPlacement'
import AdWarning from 'components/AdWarning'

import './Search.scss'
import { withTracking } from '@/modern/tracking/global/hooks/useTracking'
import { useTargetApi as targetApi } from '@/modern/hooks/useTargetApi'
import createTrackingData from '@/modern/tracking/global/helpers/createTrackingData'
import { DATALAYER_PAGES } from '@/modern/tracking/pages'
import {
  createDealerObject,
  createListItensObject,
  createSearchObject,
} from '@/modern/tracking/pages/default'
import { getBlackFairClassName } from '@/modern/utils/fairs'
import {
  createInsiderTrackObject,
  insertInsiderTag,
} from '@/modern/tracking/insiderTrack'
import { handleSearchData } from '@/utils/searchData'

import { fetchFiltersCarLocation } from '@/ducks/filtersCarLocation'
import { fetchFiltersBikeLocation } from '@/ducks/filtersBikeLocation'
import { fetchGeolocation } from 'ducks/geolocation'

import {
  fuseLoadSlots,
  fuseProcessNewSlots,
  startFuseInit,
} from '@/utils/start-publift'

import { handleGeolocationValue } from './utils'



const { itemsPerPage, paginationExperience } =  handlePaginationABCTest()

class PageSearch extends Component {
  constructor(props) {
    super(props)

    const { cookieNoticeContext, dispatchAnalyticsEvent } = this.props
    const { cookies } = cookieNoticeContext

    this.dispatchAnalyticsEvent = dispatchAnalyticsEvent

    this.cookiesState = {
      formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
    }

    this.state = {
      no: TEXT.NAO,
      yes: TEXT.SIM,
      openFooter: false,
      vehicleType: getTypeVehicle(this.props.computedMatch.params.vehicleType),
      searchResult: undefined,
      guideNavigation: undefined,
      adsCount: 0,
      listFilters: this.getListFilters(),
      actualPage: config.actualPage,
      displayPerPage: itemsPerPage,
      filters: parseSearchFilters(
        this.props.match.params.filters,
        this.props.location.search,
        this.props.computedMatch.params.vehicleType
      ),
      eventType: 'customPageView',
      disparoTrackingCarregamentoInicial: false,
      pageName: '/webmotors/comprar/resultado-antigo',
      adType: getTypeAd(this.props.computedMatch.params.vehicleType),
      scrolling: false,
      itemsScrolling: 1,
      testAB: this.getABTest(1),
      testAdsS_B: this.getABTest('desktopbanner'),
      fetchWbZeroKm: true,
      totalItemsScrolling: null,
      loadMore: false,
      newSearch: false,
      activeScroll: true,
      enabledMoreItems: true,
      quantityScrollAd: 120,
      itemsPosition: undefined,
      lastSearchCookies: {
        lastType: this.props.match.params.vehicleType
          ? this.props.match.params.vehicleType.includes('carro')
            ? VEHICLE_TYPE.car
            : VEHICLE_TYPE.bike
          : '',
      },
      filtersOpen: this.checkFiltersOpenOnLoad(),
      categoryStyling: undefined,
      storeStyling: undefined,
      hotDealStyling: undefined,
      colorBackgroundDefault: '#f3f5f8',
      sizeBackground: '',
      error404: this.customization404(),
      propertiesSearchBar: undefined,
      cardPreferences: this.getCardPreferences(),
      listCardPlaceHolder: true,
      cookieSendProposal: undefined,
      fetchingSellerInfo: false,
      sellerImgExists: { id: undefined, exists: true },
      executeCategories: true,
      originLojas: getItemUrlOrigin(this.props.location.search, 'orilojas'),
      allFilters: [],
      locationFilters: [],
      adPlacement: {},
      recommendationTimestamp: new Date()
        .toISOString()
        .replace(/T/, ' ')
        .replace(/Z/, ''),
      isABTestLoading: true,
      isLocationLoading: true,
      fetchLocationSearch: () => null,
      locationValue: '',
      isLoadingNewSearch: false,
    }

    if (typeof document === 'undefined' && config.useSSR) {
      if (typeof document === 'undefined' && !this.props.declareSeo.fetched) {
        this.props.dispatch(fetchDeclareSeo('Search'))
      }
      if (
        this.props.match.params.vehicleCategory &&
        !this.props.categories.fetched &&
         this.props.categories.status === 'idle'
      ) {
        this.props.dispatch(fetchCategories())
      } else if (
        this.props.match.params.hotDeal &&
        !this.props.hotDeal.fetched
      ) {
        this.props.dispatch(fetchHotDeal())
      } else {
        const data = this.getFetchData()
        if (!this.props.searchResult.fetched && this.props.searchResult.isPending) {
          this.props.dispatch(fetchSearchResult(data))
        } else {
          this.state = {
            ...this.state,
            ...{ listCardPlaceHolder: false },
            ...this.joinFetchedResult(data),
            ...this.setPropertiesSeo(this.props.searchResult.result),
            ...this.getCustomization(),
          }
        }
      }
    }
    this.placeholder = this.renderCardsPlaceHolder()
    this.getSearchResult = this.getSearchResult.bind(this)
    this.getCustomization = this.getCustomization.bind(this)
    this.handleOrderChange = this.handleOrderChange.bind(this)
    this.renderCards = this.renderCards.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.getSearchURL = this.getSearchURL.bind(this)
    this.setCardPreferences = this.setCardPreferences.bind(this)
    this.handleToggleFooter = this.handleToggleFooter.bind(this)
    this.sendProposal = this.sendProposal.bind(this)
    this.seePhone = this.seePhone.bind(this)
    this.getListFilters = this.getListFilters.bind(this)
    this.renderResultZero = this.renderResultZero.bind(this)
    this.handleZeroStock = this.handleZeroStock.bind(this)
    this.forceTimeout = undefined
  }

  checkFiltersOpenOnLoad() {
    // if (this.props.computedMatch.params.vehicleCategory || this.props.computedMatch.params.hotDeal)
    // 	return false
    return true
  }

  componentDidMount() {
    if (onClientSide()) {
      const { cookieNoticeContext } = this.props
      const { cookies } = cookieNoticeContext
      this.geolocationService(cookies)
    }

    const handleTargetApiCallback = () => {
      this.setState({ isABTestLoading: false })
    }

    const { env, newCardLayout, mediaZeroKm, searchResultPagination } = config.abTest

    targetApi({
      mboxes: [
        {
          name: newCardLayout.mboxName,
          keys: newCardLayout.keys,
        },
        {
          name: mediaZeroKm.mboxName,
          keys: mediaZeroKm.key
        },
        {
          name: searchResultPagination.mboxName,
          keys: searchResultPagination.key,
        },
      ],
      env,
      callback: () => handleTargetApiCallback(),
    })

    if (
      !(
        config.useSSR &&
        this.props.searchResult.fetched &&
        this.checkRequestedUrl()
      ) &&
      !this.props.searchResult.fetched
    ) {
      // caso não caia no SSR
      const initialFetch = isCustom => {
        if (isCustom) {
          this.getSearchResult(undefined, undefined, undefined, () => {})
        }
      }
      if (
        this.props.match.params.vehicleCategory &&
        !this.props.categories.fetched
      ) {
        this.props.dispatch(fetchCategories()).then(() => {
          initialFetch(true)
        })
      } else if (
        this.props.match.params.hotDeal &&
        !this.props.hotDeal.fetched
      ) {
        this.props.dispatch(fetchHotDeal()).then(() => {
          initialFetch(true)
        })
      } else {
        initialFetch(false)
      }
    }

    this.setState({
      filtersOpen: this.checkFiltersOpenOnLoad(),
    })

    if (onClientSide()) {
      if (!paginationExperience) {
        window.addEventListener('scroll', this.handleScroll, false)
        window.addEventListener('resize', this.handleScroll, false)
      }

      this.handleZeroStock()
      startFuseInit()
      const { search } = window.location
      const urlParams = new URLSearchParams(search)
      const hasSuperSealOffQueryString = urlParams.get('superSealOff') === 'on'

      this.props.dispatch({
        type: '@filter/SET',
        key: 'superSealOff',
        value: hasSuperSealOffQueryString,
      })
    }
    let orderChange = false
    getQueryParameter(this.props.location.search, 'o') && (orderChange = true)
    this.runOnMount(orderChange)
    createInsiderTrackObject({
      cookieConfig: this.props.cookieNoticeContext,
      properties: {
        page: {
          type: 'Category',
        },
      },
    })
    insertInsiderTag()
    fuseProcessNewSlots()
  }

  checkRequestedUrl() {
    if (
      this.props.searchResult &&
      this.props.searchResult.requested &&
      this.props.searchResult.requested.url ==
        encodeURIComponent(this.getSearchURL())
    )
      return true
    return false
  }

  runOnMount(setCustomization) {
    if (onClientSide()) {
      window.scrollTo(0, 0)
    }
    this.setState({
      listFilters: this.getListFilters(),
    })

    if (
      (setCustomization &&
        getQueryParameter(this.props.location.search, 'o') ==
          this.getOrderValue()) ||
      !getQueryParameter(this.props.location.search, 'o')
    ) {
      this.setCustomizationState(undefined, false)
    }
    document.querySelector('.Header').classList.add('Header--fixo')

    this.checkCustomization404()
  }

  getListFilters() {
    let _hotDeal
    let category
    const { hotDeal } = this.props
    if (this.props.computedMatch.params.hotDeal && hotDeal) {
      const _object =
        Array.isArray(hotDeal.result) &&
        hotDeal.result.find(
          x => x.URL == this.props.computedMatch.params.hotDeal
        )
      if (_object && _object.Name) {
        _hotDeal = _object.Name
      }
    }
    if (
      this.props.categories.fetched &&
      this.props.categories.result &&
      this.props.computedMatch.params.vehicleCategory
    ) {
      const _object = this.props.categories.result.find(
        x =>
          x.Url.toLowerCase().trim() ==
          this.props.computedMatch.params.vehicleCategory.toLowerCase().trim()
      )
      if (_object && _object.Nome) {
        category = _object.Nome
      }
    }
    return getFilterSelected(
      parseSearchFilters(
        this.props.match.params.filters
          ? this.props.match.params.filters
          : 'estoque',
        this.props.location.search,
        this.props.computedMatch.params.vehicleType
          ? this.props.computedMatch.params.vehicleType
          : VEHICLE_TYPE.CAR,
        category,
        _hotDeal
      ),
      this.state &&
        this.state.filters.idrevendedor &&
        this.props.searchResult &&
        this.props.searchResult.fetched &&
        this.props.searchResult.result.Seller &&
        this.props.searchResult.result.Seller?.FantasyName
        ? this.props.searchResult.result.Seller?.FantasyName
        : undefined
    )
  }

  getUrlFilters() {
    const urlFilters = parseSearchFilters(
      this.props.match.params.filters,
      this.props.location.search,
      this.props.computedMatch.params.vehicleType
    )
    if (urlFilters.tipoveiculo) {
      const vehicleType = urlFilters.tipoveiculo.includes('moto')
        ? 'bike'
        : 'car'
      const estadocidade = urlFilters.estadocidade
        ? urlFilters.estadocidade
        : 'estoque'
      delete urlFilters.tipoveiculo
      delete urlFilters.estadocidade
      const urlFiltersObj = {}
      urlFiltersObj.estadocidade = estadocidade
      urlFiltersObj.tipoveiculo = vehicleType
      urlFiltersObj[vehicleType] = urlFilters
      return urlFiltersObj
    }
  }

  fetchAutoComplete(type) {
    !type && (type = this.state.vehicleType)
    if (type == VEHICLE_TYPE.car) {
      this.fetchAutoCompCar()
    } else if (type == VEHICLE_TYPE.bike) {
      this.fetchAutoCompBike()
    }
  }

  fetchAutoCompCar() {
    if (
      !this.props.autoCompleteCar.fetched &&
      !this.state.fetchingAutoCompleteCar
    ) {
      this.setState({ fetchingAutoCompleteCar: true })
      this.props.dispatch(fetchAutoCompleteCar()).then(() => {
        if (!this.props.autoCompleteCar.fetched) {
          this.setState({ fetchingAutoCompleteCar: false })
        }
      })
    }
  }

  fetchAutoCompBike() {
    if (
      !this.props.autoCompleteBike.fetched &&
      !this.state.fetchingAutoCompleteBike
    ) {
      this.setState({ fetchingAutoCompleteBike: true })
      this.props.dispatch(fetchAutoCompleteBike()).then(() => {
        if (!this.props.autoCompleteBike.fetched) {
          this.setState({ fetchingAutoCompleteBike: false })
        }
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (onClientSide()) {
      this.setPubliftSegmentation()

      if (this.state.isLoadingNewSearch && paginationExperience && !this.state.searchResult) {
        window.scrollTo({ top: 0 });
      }

      if (
        this.props.location.pathname != prevProps.location.pathname ||
        this.props.location.search != prevProps.location.search
      ) {
        this.handleZeroStock()
        let orderChange = true
        if (
          this.props.location.pathname == prevProps.location.pathname &&
          removeQueryParameter(this.props.location.search, 'o') ===
            removeQueryParameter(prevProps.location.search, 'o') &&
          getQueryParameter(this.props.location.search, 'o') !=
            getQueryParameter(prevProps.location.search, 'o')
        ) {
          orderChange = true
          this.pushOrderChange(
            getQueryParameter(this.props.location.search, 'o')
          )
        }
        this.resetSearch(orderChange)
      }
    }
    if (
      (this.props.match.params.vehicleCategory &&
        !this.props.categories.error) ||
      (this.props.match.params.hotDeal && !this.props.hotDeal.error)
    ) {
      this.checkCustomization404()
    } else if (
      ((this.props.match.params.vehicleCategory &&
        !getQueryParameter(this.props.location.search, 'necessidade')) ||
        (this.props.match.params.hotDeal &&
          !getQueryParameter(this.props.location.search, 'feirao'))) &&
      !this.state.error404
    ) {
      this.setState({ error404: true })
    }

    if (
      this.props.searchResult.result &&
      this.props.searchResult.result.SearchResults &&
      this.props.searchResult.result.SearchResults[0] &&
      this.props.searchResult.requested.vehicleType == this.state.vehicleType &&
      this.state.filters.idrevendedor ==
        this.props.searchResult.result.SearchResults[0]?.Seller?.Id &&
      !this.state.fetchingSellerInfo
    ) {
      this.setState({ fetchingSellerInfo: true }, () => {
        this.checkSellerID()
      })
    } else if (
      this.state.fetchingSellerInfo &&
      (this.state.filters.idrevendedor || prevState.filters.idrevendedor) &&
      (this.state.filters.idrevendedor != prevState.filters.idrevendedor ||
        this.state.vehicleType != prevState.vehicleType)
    ) {
      this.setState({ fetchingSellerInfo: false, storeStyling: undefined })
    }

    const oldCookies = prevProps.cookieNoticeContext.cookies
    const { cookies } = this.props.cookieNoticeContext
    if (
      JSON.stringify(oldCookies[COOKIE_NOTICE_TYPES.PROPOSALS]) !==
      JSON.stringify(cookies[COOKIE_NOTICE_TYPES.PROPOSALS])
    ) {
      this.cookiesState = {
        ...this.cookiesState,
        formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
      }
    }
    if (
      JSON.stringify(prevProps.cookieNoticeContext) !==
      JSON.stringify(this.props.cookieNoticeContext)
    ) {
      createInsiderTrackObject({
        cookieConfig: this.props.cookieNoticeContext,
        properties: {
          page: {
            type: 'Category',
          },
        },
      })
    }
  }

  createDetailData() {
    const data = {
      vehicleType: this.state.vehicleType,      
      idAnuncio: this.props.searchResult.result.SearchResults[0].UniqueId,
    }

    data.brand = cleanString(
      this.props.searchResult.result.SearchResults[0].Specification.Make.Value,
      {
        toLowerCase: 1,
        removeAccents: 1,
        removeDots: 1,
        slugify: 1,
      }
    )

    data.model = cleanString(
      this.props.searchResult.result.SearchResults[0].Specification.Model.Value,
      {
        toLowerCase: 1,
        removeAccents: 1,
        removeDots: 1,
        slugify: 1,
      }
    )

    data.version = cleanString(
      this.props.searchResult.result.SearchResults[0].Specification.Version
        .Value,
      {
        toLowerCase: 1,
        removeAccents: 1,
        removeDots: 1,
        slugify: 1,
      }
    )

    data.city = cleanString(
      this.props.searchResult.result.SearchResults[0].Seller?.City,
      {
        toLowerCase: 1,
        removeAccents: 1,
        removeDots: 1,
        slugify: 1,
      }
    )

    data.price = cleanString(
      this.props.searchResult.result.SearchResults[0].Prices.Price,
      {
        toLowerCase: 1,
        removeAccents: 1,
        removeDots: 1,
        slugify: 1,
      }
    )

    const yearFabrication =
      this.props.searchResult.result.SearchResults[0].Specification
        .YearFabrication
    const yearModel = parseInt(
      this.props.searchResult.result.SearchResults[0].Specification.YearModel
    ).toString()
    data.year =
      yearModel == yearFabrication
        ? yearModel
        : `${yearFabrication}-${yearModel}`

    if (this.state.vehicleType == VEHICLE_TYPE.CAR) {
      data.version = cleanString(
        this.props.searchResult.result.SearchResults[0].Specification.Version
          .Value,
        {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        }
      )

      data.doors = `${this.props.searchResult.result.SearchResults[0].Specification.NumberPorts}-portas`
    } else {
      data.cc = `${parseInt(
        this.props.searchResult.result.SearchResults[0].Specification
          .CubicCentimeter
      )}cc`
    }

    return data
  }

  checkSellerID() {
    if (
      this.props.searchResult.result &&
      this.props.searchResult.result.SearchResults &&
      this.props.searchResult.result.SearchResults[0] &&
      this.props.searchResult.result.SearchResults[0].UniqueId
    ) {
      this.getFilterSelected(this.getListFilters())
      this.getObjDataLayer(this.state.eventType)
      if (
        this.props.searchResult.result.SearchResults[0].Seller?.SellerType ==
          'PJ' &&
        this.props.searchResult.result.SearchResults[0].Seller?.Id
      ) {
        const doc = this.props.searchResult.result.SearchResults[0].Seller?.Id
        this.props.dispatch(fetchDealerInfo(doc)).then(() => {
          if (
            this.props.dealerInfo.fetched &&
            this.props.dealerInfo.requested.Id == doc
          ) {
            if (
              this.props.dealerInfo.result.shield &&
              (this.props.dealerInfo.result.shield.includes(SELLERSHIELD.P) ||
              this.props.dealerInfo.result.shield.includes(
                SELLERSHIELD.M
              ) ||                
              this.props.dealerInfo.result.shield.includes(SELLERSHIELD.G))
            ) {
              this.setState(
                {
                  storeStyling: {
                    id: this.state.filters.idrevendedor,
                    CorPrimaria: 'transparent',
                    BannerDesktop: `${
                      config.sellerShieldImg +
                      this.props.searchResult.result.SearchResults[0].Seller?.Id
                    }/DESKTOP.jpg`,
                  },
                },
                () => {
                  this.getObjDataLayer(this.state.eventType)
                }
              )
            } else {
              this.setState({ storeStyling: undefined })
            }
          }
        })
      }
    }
  }

  componentWillUnmount() {
    if (onClientSide()) {
      if (!paginationExperience) {
        window.addEventListener('scroll', this.handleScroll, false)
        window.addEventListener('resize', this.handleScroll, false)
      }

      window.removeEventListener('visibilitychange', pauseRefresh)
    }
    this.props.dispatch({ type: '@filter/RESET' })
  }

  getABTest(value) {
    return decodeURIComponent(encodeURIComponent(this.getSearchURL()))
      .toLocaleLowerCase()
      .includes(`ab=${value}`)
  }

  resetSearch(orderChange) {
    const type = this.props.computedMatch.params.vehicleType
    this.setState(
      {
        adType: getTypeAd(type),
        vehicleType: getTypeVehicle(type),
        listFilters: getFilterSelected(
          parseSearchFilters(
            this.props.match.params.filters,
            this.props.location.search,
            type
          )
        ),
        actualPage: config.actualPage,
        newSearch: false,
      },
      () => {
        this.runOnMount(orderChange)
        this.setState({
          filters: parseSearchFilters(
            this.props.match.params.filters,
            this.props.location.search,
            type
          ),
        })
      }
    )

    fuseLoadSlots()
  }

  handleToggleFooter(_state) {
    this.setState({
      openFooter: !!_state,
    })
  }

  setFilterStates(obj) {
    if (obj && typeof obj === 'object') {
      this.setState({ lastSearchCookies: obj })
      const emptyFilters = JSON.parse(JSON.stringify(obj))
      emptyFilters.bike = ''
      emptyFilters.car = ''
      this.setState({ emptyFiltersObj: emptyFilters })
    }
  }

  toggleFilter() {
    this.setState({ filtersOpen: !this.state.filtersOpen })
  }

  analyzeLastSearchCookie(route, query) {
    route = route.split('/')
    const vehicleType = route.shift()
    route = route.join('/')
    return parseSearchFilters(route, query, vehicleType)
  }

  setSearchesCookie() {
    if (
      onClientSide() &&
      this.state.filters &&
      this.state.filters.marca1 &&
      this.state.filters.modelo1
    ) {
      const { cookies } = this.props.cookieNoticeContext
      const isCookieCategoryActive = cookieCategoryIsActive(
        cookies,
        COOKIES.LAST_SEARCHES
      )

      if (isCookieCategoryActive) {
        let _searchCookies = getCookie(COOKIES.LAST_SEARCHES)
        clearCookie(COOKIES.LAST_SEARCHES)
        if (_searchCookies) {
          _searchCookies = JSON.parse(_searchCookies)
        }
        if (
          typeof _searchCookies === 'undefined' ||
          !_searchCookies.constructor == Array
        ) {
          _searchCookies = []
        }
        if (_searchCookies.constructor === Array) {
          _searchCookies.unshift({
            route: `${this.props.match.params.vehicleType}/${this.props.match.params.filters}`,
            query: this.props.location.search
              ? this.getUrlQueryValid(this.props.location.search)
              : '',
          })
          _searchCookies = _searchCookies.slice(0, 11)
          const thisSearchFilters = JSON.stringify(
            this.analyzeLastSearchCookie(
              _searchCookies[0].route,
              _searchCookies[0].query
            )
          )
          for (let i = 1; i < _searchCookies.length; i++) {
            if (
              thisSearchFilters.toLowerCase() ==
              JSON.stringify(
                this.analyzeLastSearchCookie(
                  _searchCookies[i].route,
                  _searchCookies[i].query
                )
              ).toLowerCase()
            ) {
              _searchCookies.splice(i, 1)
            }
          }
          for (
            let length = 10;
            JSON.stringify(_searchCookies.slice(0, 10)).length > 4000;
            length--
          ) {
            // pra garantir que o cookie não vai estourar o limite
            _searchCookies = _searchCookies.slice(0, length)
          }
          setCookie(
            COOKIES.LAST_SEARCHES,
            JSON.stringify(_searchCookies.slice(0, 10)),
            90
          )
        } else {
          clearCookie(COOKIES.LAST_SEARCHES)
        }
      } else {
        clearCookie(COOKIES.LAST_SEARCHES)
      }
    }
  }

  getUrlQueryValid(querySearch) {
    let _newQuerySearch = ''
    const _paramsInvalid = ['idcmpint', 'autocomplete', 'o']
    if (querySearch && typeof querySearch === 'string') {
      querySearch = querySearch.replace(/^\?/, '').split('&')
      for (let i = 0; i < querySearch.length; i++) {
        const queryValue = querySearch[i].split('=')
        if (!_paramsInvalid.includes(queryValue[0])) {
          _newQuerySearch += `${querySearch[i]}&`
        }
      }
      return _newQuerySearch
        ? `?${_newQuerySearch.substr(0, _newQuerySearch.length - 1)}`
        : undefined
    }
  }

  handleScroll() {
    if (onClientSide()) {
      const { cookies } = this.props.cookieNoticeContext
      const isCookieCategoryActive = cookieCategoryIsActive(
        cookies,
        COOKIES.TRACKING_FROM
      )

      const { scrolling, totalItemsScrolling, actualPage } = this.state
      // const _lastItem = document.querySelector('.WhiteBox:nth-last-child(3)')
      const _lastItem = ReactDOM.findDOMNode(this.refs.lastItem)
      const _lastItemOffset = _lastItem
        ? _lastItem.offsetTop + _lastItem.clientHeight
        : undefined
      const _pageYOffset = window.pageYOffset
      const _pageOffset = _pageYOffset + window.innerHeight
      const _containerQtd = this.state.searchResult
        ? this.state.searchResult.length
        : undefined
      const _endscroll = 50

      if (scrolling) return
      if (totalItemsScrolling <= actualPage) return
      if (!_containerQtd) return

      if (_containerQtd < this.state.quantityScrollAd) {
        const _totalPagesPagination =
          this.state.adsCount / this.state.displayPerPage
        let hasPagination = true

        if (this.state.actualPage < _totalPagesPagination) {
          this.setState({ enabledMoreItems: true })
        } else {
          this.setState({ enabledMoreItems: false, newSearch: true })
          hasPagination = false
        }
        if (_containerQtd < this.state.adsCount && hasPagination) {
          if (_containerQtd < this.state.adsCount) {
            if (_pageOffset > _lastItemOffset - _endscroll) {
              this.loadMoreItems()
              if (isCookieCategoryActive) {
                setEventToLazyDispatch('paginacaoRealizada')
              }
            }
          }
        } else {
          return false
        }
      } else if (!_containerQtd && !_lastItemOffset) {
        return false
      } else {
        this.setState({ newSearch: true })
        return false
      }
    }
  }

  loadMoreItems = () => {
    this.setState(
      prevState => ({
        actualPage: prevState.actualPage + 1,
        scrolling: true,
        loadMore: true,
      }),
      this.getSearchResult
    )
  }

  handlePageChange = (page) => {
    this.setState({
        actualPage: page,
        isLoadingNewSearch: true,
        scrolling: false,
        loadMore: true,
        searchResult: undefined,
      },
      this.getSearchResult
    )
    sendDispatchEvent('paginacaoNumeral')
  }

  saveSearchCookie(vehicleType, setParametersFromApi, result, location, match) {
    if (onClientSide() && !this.state.error404) {
      const { cookies } = this.props.cookieNoticeContext
      const isCookieCategoryActive = cookieCategoryIsActive(
        cookies,
        COOKIES.FILTER_SEARCH
      )

      const thisCookieVersion = 'v3'
      const _searchCookie =
        isCookieCategoryActive && getCookie(COOKIES.FILTER_SEARCH)
      let newCookie
      const emptyCookie = {
        car: 'carros/estoque',
        bike: 'motos/estoque',
        estadocidade: '',
        lastType: vehicleType,
        cookie: thisCookieVersion,
      }
      if (_searchCookie && _searchCookie.substring(0, 1) == '{') {
        newCookie = JSON.parse(getCookie(COOKIES.FILTER_SEARCH))
        if (!newCookie.cookie || newCookie.cookie != thisCookieVersion) {
          newCookie = emptyCookie
        }
      } else {
        newCookie = emptyCookie
      }
      newCookie[vehicleType] =
        location.pathname + (location.search ? location.search : '')
      newCookie[vehicleType].substring(0, 1) == '/' &&
        (newCookie[vehicleType] = newCookie[vehicleType].substring(1))
      newCookie.estadocidade = location.search
        ? getQueryParameter(location.search, 'estadocidade')
        : 'estoque'
      if (newCookie.estadocidade == 'estoque') {
        let shortCityState = parseSearchFilters(
          match.params.filters
        ).estadocidade
        if (/(^\w{2})\-/.test(shortCityState)) {
          shortCityState = `${returnStateLong(
            /(^\w{2})\-(.*)/.exec(shortCityState)[1]
          )} - ${/(^\w{2})\-(.*)/.exec(shortCityState)[2].replace('-', ' ')}`
        }
        newCookie.estadocidade = cleanString(shortCityState, {
          capitalizeAll: 1,
        })
      }
      const apiFilters = {}
      const parsedApiFilters = {}
      if (result) {
        if (result.Filters) {
          for (let i = 0; i < result.Filters.length; i++) {
            const saveObj = ''
            const { name } = result.Filters[i]
            if (name == 'State' || name == 'Make') {
              apiFilters[name] = result.Filters[i].items
            }
          }
        }
        if (result.FilterCustom) {
          if (result.FilterCustom.AnoDe || result.FilterCustom.AnoAte)
            newCookie.ano = {
              anode: result.FilterCustom.AnoDe
                ? parseInt(result.FilterCustom.AnoDe)
                : 0,
              anoate: result.FilterCustom.AnoAte
                ? parseInt(result.FilterCustom.AnoAte)
                : 0,
            }
          else newCookie.ano = { anode: undefined, anoate: undefined }
          const { precode, precoate } = this.state.filters
          if (precode || precoate)
            newCookie.preco = {
              precode: precode || undefined,
              precoate: precoate || undefined,
            }
          else {
            newCookie.preco = {
              precode: precode || undefined,
              precoate: precoate || undefined,
            }
          }
        }
      }
      if (apiFilters.State) {
        const State = this.parseSelectedApiFilterObj(apiFilters.State)
        if (State && State.name) {
          parsedApiFilters.State = State.name
          const City = this.parseSelectedApiFilterObj(State.items)
          if (City && City.name) {
            parsedApiFilters.City = City.name
          }
        }
      }

      const { searchResult } = this.props
      const { FilterCustom = {} } = searchResult?.result

      if (FilterCustom.Veiculos?.length) {
        const [firstVehicle] = FilterCustom.Veiculos.map(
          ({ Marca = '', Modelo = '', Versao = '' }) => ({
            name: Marca,
            model: Modelo,
            version: Versao,
          })
        )

        if (firstVehicle) {
          const { name, model, version } = firstVehicle

          parsedApiFilters.Make = name
          parsedApiFilters.Model = model
          parsedApiFilters.Version = version
        }
      }

      if (
        parsedApiFilters.State &&
        /\s\(\w{2}\)/.test(parsedApiFilters.State)
      ) {
        parsedApiFilters.State = parsedApiFilters.State.replace(
          /\s\(\w{2}\)/,
          ''
        ).trim()
      }
      let newCookieParams = newCookie[vehicleType].includes('?')
        ? newCookie[vehicleType].split('?')[1]
        : ''
      newCookieParams = parsedApiFilters.State
        ? insertQueryParameter(
            newCookieParams,
            'estadocidade',
            parsedApiFilters.State +
              (parsedApiFilters.City ? ` - ${parsedApiFilters.City}` : '')
          )
        : newCookieParams
      newCookieParams = parsedApiFilters.Make
        ? insertQueryParameter(newCookieParams, 'marca1', parsedApiFilters.Make)
        : newCookieParams
      newCookieParams = parsedApiFilters.Model
        ? insertQueryParameter(
            newCookieParams,
            'modelo1',
            parsedApiFilters.Model
          )
        : newCookieParams
      newCookieParams = parsedApiFilters.Version
        ? insertQueryParameter(
            newCookieParams,
            'versao1',
            parsedApiFilters.Version
          )
        : newCookieParams
      newCookie[vehicleType] =
        (newCookie[vehicleType].includes('?')
          ? newCookie[vehicleType].split('?')[0]
          : newCookie[vehicleType]) +
        (newCookieParams ? `?${newCookieParams}` : '')
      newCookie.estadocidade = parsedApiFilters.State
        ? parsedApiFilters.State +
          (parsedApiFilters.City ? ` - ${parsedApiFilters.City}` : '')
        : 'estoque'
      parsedApiFilters.Make
        ? (newCookie.marca = parsedApiFilters.Make)
        : (newCookie.marca = '')
      parsedApiFilters.Model
        ? (newCookie.modelo = parsedApiFilters.Model)
        : (newCookie.modelo = '')
      newCookie.lastType = vehicleType
      newCookie.cookie = thisCookieVersion
      if (isCookieCategoryActive) {
        setCookie(COOKIES.FILTER_SEARCH, JSON.stringify(newCookie))
      } else {
        clearCookie(COOKIES.FILTER_SEARCH)
      }
      this.setFilterStates(newCookie)
    }
  }

  parseSelectedApiFilterObj(obj) {
    if (obj && obj.length) {
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].selected) {
          return obj[i]
        }
      }
    }
    return undefined
  }

  getFetchData(searchUrl) {
    return {
      url: encodeURIComponent(this.getSearchURL()),
      vehicleType: this.state.vehicleType,
      actualPage: this.state.actualPage,
      displayPerPage: this.state.displayPerPage,
      order: this.getOrderValue(),
      showMenu: true,
      showCount: true,
      showBreadCrumb: true,
      testAB: this.state.testAB,
      returnUrl: false,
      category: this.state.categoryStyling,
      hotDeal: this.state.hotDealStyling,
      literalUrl: this.getLiteralUrl(),
    }
  }

  getLiteralUrl() {
    return this.props.history && this.props.history.location
      ? this.props.history.location.pathname +
          (this.props.history.location.search
            ? this.props.history.location.search
            : '')
      : ''
  }

  getSearchResult(searchUrl, pushUrl, reTry, callback) {
    if (typeof document === 'undefined') {
      return false
    }

    if (this.state.actualPage > 1) {
      this.setState({ loadMore: true })
    }

    const userHasPermissionGeolocation = this.props.geolocation.userHasPermissionLocation
    const { cookieNoticeContext } = this.props
    const { geolocationValue = {} } = handleGeolocationValue({
      cookieNoticeContext,
      filters: this.state.filters,
      userHasPermissionGeolocation
    })

    if (onClientSide() && geolocationValue && geolocationValue.estadocidade) {
      const hasForcedLocation = window.sessionStorage.getItem(
        'shouldNotForceLocation'
      )
      const searchParams = new URLSearchParams(document.location.search)
      const paramsKeys = [...searchParams.keys()]
      const hasDealerId = paramsKeys.some(
        paramKey => paramKey.toLowerCase() === 'idrevendedor'
      )

      if (!hasForcedLocation && !hasDealerId) {
        const { estadocidade, localizacao } = geolocationValue
        const [city = '', state = ''] = estadocidade.split(' - ')

        if (!state) return false

        const stateCityParam = city
          ? `${returnStateLong(state)}-${city}`
          : returnStateLong(state)

        searchParams.set('estadocidade', stateCityParam)

        const currentUrl = new URL(document.location.href);
        const isOfficialStore = currentUrl.pathname.includes("lojaoficial");
        const defaultRadius = isOfficialStore ? '0km' : '100km'

        const { latitude, longitude } = localizacao || {}
        const latLong =
          latitude && longitude ? `${latitude},${longitude}x${defaultRadius}` : ''

        if (latLong) {
          searchParams.set('localizacao', latLong)
        }

        let customParams = ''
        for (const [key, value] of searchParams) {
          if (customParams.length > 0) customParams += '&'
          customParams += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        }

        this.props.history.push({ search: customParams })

        this.setState({
          locationValue: geolocationValue.estadocidade,
        })

        return false
      }
    }

    const data = this.getFetchData()

    if (!paginationExperience) {
      if (
        this.props.searchResult.fetched &&
        this.props.searchResult.requested.url == data.url &&
        this.state.actualPage == 1
      ) {
        if (this.state.listCardPlaceHolder) {
          this.setState({ listCardPlaceHolder: false })
          this.joinFetchedResult(data)
        }
  
        return false
      }
    }

    if (
      (data &&
        data.vehicleType == 'car' &&
        !/^(motos(\-novas)?(\-usadas)?)/.test(decodeURIComponent(data.url)) &&
        !decodeURIComponent(data.url).includes('tipoveiculo=motos')) ||
      (data &&
        data.vehicleType == 'bike' &&
        !/^(carros(\-novos)?(\-usados)?)/.test(decodeURIComponent(data.url)) &&
        !decodeURIComponent(data.url).includes('tipoveiculo=carros'))
    ) {
      const { searchResult } = this.state
      this.setState(
        { fetching: true, listCardPlaceHolder: !(this.state.actualPage > 1) },
        () => {
          this.props
            .dispatch(fetchSearchResult(data))
            .then(() => {
              if (data.url == encodeURIComponent(this.getSearchURL())) {
                if (callback) {
                  callback()
                }
                this.setState(
                  { fetching: false, listCardPlaceHolder: false, isLoadingNewSearch: false },
                  () => {
                    this.joinFetchedResult(data)
                  }
                )
              } else {
                if (this.forceTimeout) {
                  clearTimeout(this.forceTimeout)
                }
                this.forceTimeout = setTimeout(() => {
                  if (this.state.listCardPlaceHolder) {
                    this.getSearchResult(undefined, undefined, true)
                  }
                }, 5000)
              }
            })
            .finally(() => {
              fuseProcessNewSlots()
            })
        }
      )
    } else if (!reTry) {
      setTimeout(() => {
        this.getSearchResult(undefined, undefined, true)
      }, 2000)
    } else {
      this.props.history.push(
        `/${data.vehicleType == 'bike' ? 'motos' : 'carros'}`
      )
    }
  }

  joinFetchedResult(data) {
    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.TRACKING_FROM
    )

    if (!this.checkRequestedUrl()) {
      return false
    }
    const { result } = this.props.searchResult
    this.saveSearchCookie(
      data.vehicleType,
      true,
      result,
      this.props.location,
      this.props.match
    )
    if (
      this.props.searchResult.fetched &&
      this.props.searchResult.result.SearchResults
    ) {
      const currentSearch = this.props.searchResult.result.SearchResults
      let listMerge = []

      if (!paginationExperience) {
        listMerge =
          this.state.actualPage !== 1
            ? listMerge.concat(
                this.state.searchResult,
                this.props.searchResult.result.SearchResults
              )
            : this.props.searchResult.result.SearchResults
      } else {
        listMerge = this.props.searchResult.result.SearchResults
      }

      this.setSearchesCookie()
      let obj = {
        searchResult: listMerge || [],
        guideNavigation: this.props.searchResult.result.Filters || undefined,
        scrolling: false,
        totalItemsScrolling:
          this.props.searchResult.result.searchResults || undefined,
        adsCount: this.props.searchResult.result.Count,
        loadMore: false,
        itemsPosition: getItemPosition(currentSearch),
        allFilters: this.props.searchResult.result.Filters,
        locationFilters: this.props.searchResult.result.FilterCustom,
        ...this.getCustomization(),
      }
      if (typeof document === 'undefined') {
        obj = { ...obj, ...{ fetching: false, listCardPlaceHolder: false } }
        return obj
      }
      if (onClientSide()) {
        const doAfter = () => {
          this.getFilterSelected(this.getListFilters())

          const { searchResult } = this.props

          this.setState({
            ...this.setPropertiesSeo(searchResult.result),
          })

          if (searchResult.result.Count == 0 || this.isUnavailable()) {
            sendDispatchEvent('buscaSemResultado')
            this.getBestSellers()
          } else if (isCookieCategoryActive) {
            const cookieEvent = getCookie(COOKIES.TRACKING_FROM)
            const { eventType } = this.state

            const trackingEvent = cookieEvent || eventType

            this.getObjDataLayer(trackingEvent)
            clearCookie(COOKIES.TRACKING_FROM)
          }
        }
        this.setState(obj, doAfter)
      }
    }
  }

  setPubliftSegmentation() {
    const search = getVehicleFilterCookie()
    const fusetag = window.fusetag || (window.fusetag = { que: [] })
    if (search && fusetag.setTargeting) {
      const params = new URLSearchParams(window.location.search)
      if(search.lastType) fusetag.setTargeting('veiculo', search.lastType)
      if(search.marca) fusetag.setTargeting('marca', search.marca)
      if(search.modelo) fusetag.setTargeting('modelo', search.modelo)
      if(search.ano) {
        const _valor = checkValueYear(search.ano)
        _valor && fusetag.setTargeting('ano', _valor.toString())
      }
      if (this.state.vehicleType == VEHICLE_TYPE.CAR) {
        if(params.get('versao1')) fusetag.setTargeting('versao', params.get('versao1'))
      }
      if(search.preco) {
        const _valor = checkValuePrice(search.preco)
        _valor && fusetag.setTargeting('preco', _valor.toString())
    }
  }
}

  setPropertiesSeo(result) {
    const _seo = result.FilterCustom ? getTag(result) : undefined
    const _breadCrumb =
      result.SEO && result.SEO.BreadCrumb ? result.SEO.BreadCrumb : ''
    const _canonical =
      result.SEO && result.SEO.Canonical ? result.SEO.Canonical : ''
    return {
      title: _seo != undefined && _seo.Title ? _seo.Title : '',
      description:
        _seo != undefined && _seo.Description ? _seo.Description : '',
      h1: _seo != undefined && _seo.H1 ? _seo.H1 : '',
      breadCrumb: _breadCrumb,
      canonical: _canonical,
    }
  }

  getBestSellers() {
    let location = getCookieLocation()
    location =
      location != '' && location != 'estoque'
        ? generateLocationState(location)
        : 'br'
    this.props.dispatch(fetchBestSellers(location))
  }

  setCustomizationState(callback, dontGetResult) {
    const custom = this.getCustomization()
    if (
      typeof custom !== 'undefined' ||
      custom.hotDealStyling ||
      custom.categoryStyling ||
      custom.makeModelStyling
    ) {
      let _styling
      let _key
      if (custom.categoryStyling) {
        _styling = custom.categoryStyling
        _key = 'categoryStyling'
      } else if (custom.hotDealStyling) {
        _styling = custom.hotDealStyling
        _key = 'hotDealStyling'
      } else if (custom.makeModelStyling) {
        _styling = custom.makeModelStyling
        _key = 'makeModelStyling'
      }
      this.setState({ [_key]: _styling }, () => {
        callback && callback()
        setTimeout(() => {
          !dontGetResult && this.getSearchResult()
        }, 1)
      })
    } else if (
      !this.props.match.params.vehicleCategory &&
      !this.props.match.params.hotDeal
    ) {
      callback && callback()
      setTimeout(() => {
        !dontGetResult && this.getSearchResult()
      }, 1)
    }
  }

  getCustomization() {
    const _category = this.props.match.params.vehicleCategory
    const _hotDeal = this.props.match.params.hotDeal
    const { hotDeal } = this.props
    if (_category) {
      if (
        this.props.categories &&
        this.props.categories != undefined &&
        this.props.categories.fetched
      ) {
        const _object = this.props.categories.result.find(
          x => x.Url == _category
        )
        if (_object) {
          return { categoryStyling: _object }
        }
      } else {
        this.props.dispatch(fetchCategories()).then(() => {
          if (this.props.categories.fetched) {
            const _object = this.props.categories.result.find(
              x => x.Url == _category
            )
            if (_object) {
              return { categoryStyling: _object }
            }

            return { categoryStyling: undefined }
          }

          return { categoryStyling: undefined }
        })
      }
    } else if (_hotDeal) {
      if (
        this.props.hotDeal &&
        this.props.hotDeal != undefined &&
        this.props.hotDeal.fetched
      ) {
        const _object =
          Array.isArray(hotDeal.result) &&
          hotDeal.result.find(x => x.URL == _hotDeal)
        if (_object) {
          const _hotDeal = {
            hotDealStyling: _object.BannerDesktop
              ? {
                  URL: _object.URL,
                  NomeHotDeal: _object.Name,
                  CorPrimaria: 'transparent',
                  BannerDesktop:
                    config.urlHotDealImages + _object.BannerDesktop,
                  Regulation: _object.Regulamento
                    ? config.urlHotDealRegulation + _object.Regulamento
                    : undefined,
                }
              : undefined,
          }
          return _hotDeal
        }
      } else {
        this.props.dispatch(fetchHotDeal()).then(() => {
          if (this.props.hotDeal.fetched) {
            const _object =
              Array.isArray(hotDeal.result) &&
              hotDeal.result.find(x => x.URL == _hotDeal)
            if (_object) {
              const _hotDeal = {
                hotDealStyling: _object.BannerDesktop
                  ? {
                      URL: _object.URL,
                      NomeHotDeal: _object.Name,
                      CorPrimaria: 'transparent',
                      BannerDesktop:
                        config.urlHotDealImages + _object.BannerDesktop,
                      Regulation: _object.Regulamento
                        ? config.urlHotDealRegulation + _object.Regulamento
                        : undefined,
                    }
                  : undefined,
              }
              return _hotDeal
            } else {
              const _hotDeal = { hotDealStyling: undefined }
              return _hotDeal
            }
          }

          return _hotDeal
        })
      }
    }
    if (
      // customização de marca/modelo
      customMakeModels &&
      customMakeModels.makes &&
      this.state.filters.marca1 &&
      (!this.state.filters.marca2 ||
        this.state.filters.marca2 == this.state.filters.marca1) &&
      (!this.state.filters.marca3 ||
        this.state.filters.marca3 == this.state.filters.marca1) &&
      (!this.state.filters.anunciante ||
        (this.state.filters.anunciante &&
          !this.state.filters.anunciante.includes('Loja'))) &&
      customMakeModels.makes[
        cleanString(decodeURIComponent(this.state.filters.marca1), {
          toLowerCase: 1,
          removeAccents: 1,
          slugify: 1,
        })
      ]
    ) {
      // debugger
      const _marca = cleanString(
        decodeURIComponent(this.state.filters.marca1),
        {
          toLowerCase: 1,
          removeAccents: 1,
          slugify: 1,
        }
      )
      const _modelo = cleanString(
        decodeURIComponent(this.state.filters.modelo1),
        { toLowerCase: 1, removeAccents: 1, slugify: 1 }
      )
      if (
        customMakeModels.makes[_marca].certifiedSeal &&
        getQueryParameter(this.props.location.search, 'atributos') &&
        customMakeModels.makes[_marca].certifiedSeal.param ==
          decodeURIComponent(
            getQueryParameter(this.props.location.search, 'atributos')
          )
      ) {
        const _makeModel = {
          Nome: customMakeModels.makes[_marca].certifiedSeal.title,
          CorPrimaria: 'transparent',
          BannerDesktop: customMakeModels.makes[_marca].certifiedSeal.imgUrl,
          DarkText: customMakeModels.makes[_marca].certifiedSeal.darkText,
          ModelStyling: false,
          CTA: false,
          bgColor: customMakeModels.makes[_marca].certifiedSeal.bgColor,
        }
        return { makeModelStyling: _makeModel }
      }
      if (
        this.state.filters.modelo1 &&
        (!this.state.filters.marca2 ||
          (this.state.filters.marca2 == this.state.filters.marca1 &&
            this.state.filters.modelo2 == this.state.filters.modelo1)) &&
        (!this.state.filters.marca3 ||
          (this.state.filters.marca3 == this.state.filters.marca1 &&
            this.state.filters.modelo3 == this.state.filters.modelo1)) &&
        customMakeModels.makes[_marca].models[_modelo]
      ) {
        const _makeModel = {
          Nome: this.getCurrentMakeModel(),
          CorPrimaria: 'transparent',
          BannerDesktop: customMakeModels.makes[_marca].models[_modelo].imgUrl,
          LinkBanner: customMakeModels.makes[_marca].models[_modelo].link,
          DarkText: customMakeModels.makes[_marca].models[_modelo].darkText,
          ModelStyling: true,
          CTA: true,
        }
        return { makeModelStyling: _makeModel }
      }
      const _makeModel = {
        Nome: this.getCurrentMakeModel(true),
        CorPrimaria: 'transparent',
        BannerDesktop: customMakeModels.makes[_marca].imgUrl,
        LinkBanner: customMakeModels.makes[_marca].link,
        DarkText: customMakeModels.makes[_marca].darkText,
        ModelStyling: false,
        CTA: true,
      }
      if (customMakeModels.makes[_marca].showMake)
        return { makeModelStyling: _makeModel }

      return { makeModelStyling: undefined }
    }
    return { makeModelStyling: undefined }
  }

  handleMediaBannerClick() {
    if (this.state.categoryStyling) {
      sendDispatchEvent('cliqueBannerCategoria')
    } else if (
      this.state.makeModelStyling &&
      this.state.makeModelStyling.ModelStyling
    ) {
      sendDispatchEvent('cliqueBannerResultadoDeBuscaModelo')
    } else if (
      this.state.makeModelStyling &&
      !this.state.makeModelStyling.ModelStyling
    ) {
      sendDispatchEvent('cliqueBannerResultadoDeBusca')
    }
  }

  checkCustomization404() {
    const error404 = this.customization404()
    this.state.error404 != error404 && this.setState({ error404 })
  }

  customization404() {
    // na verdade é o TEMA na nossa nomenclatura interna /// false = tudo ok, true = 404
    if (this.props.computedMatch.params.urlGranted) {
      this.props.history.push('/carros/estoque')
      return false
    } // Caso nao veja preenchido é porque nao é uma url valida e redireciona para NotFound
    const _category = this.props.computedMatch.params.vehicleCategory
    const _hotDeal = this.props.computedMatch.params.hotDeal
    if (this.props.computedMatch.params.urlNotBuy) return true
    if (_category) {
      if (
        this.props.categories &&
        this.props.categories != undefined &&
        this.props.categories.fetched
      ) {
        const _objectCategory = this.props.categories.result.find(
          x => x.Url.trim().toLowerCase() == _category.trim().toLowerCase()
        )
        if (_objectCategory) {
          return false
        }
        return true
      }
      if (onClientSide()) {
        if (!this.fetchingCategories) {
          this.fetchingCategories = true
          this.props.dispatch(fetchCategories()).then(() => {
            this.fetchingCategories = false
          })
        }
      }
    } else if (_hotDeal) {
      if (
        this.props.hotDeal &&
        this.props.hotDeal != undefined &&
        this.props.hotDeal.fetched
      ) {
        const { hotDeal } = this.props
        const _objectHotDeal =
          Array.isArray(hotDeal.result) &&
          hotDeal.result.find(
            x => x.URL.trim().toLowerCase() == _hotDeal.trim().toLowerCase()
          )
        if (_objectHotDeal) {
          return false
        }
        return true
      }
      if (onClientSide()) {
        if (!this.fetchingHotDeal) {
          this.fetchingHotDeal = true
          this.props.dispatch(fetchHotDeal()).then(() => {
            this.fetchingHotDeal = false
          })
        }
      }
    }
    return false
  }

  getSearchURL() {
    let url =
      (this.props.computedMatch.params.hotDeal
        ? `ofertas/feiroes/${this.props.computedMatch.params.hotDeal}/`
        : '') +
      (this.props.computedMatch.params.vehicleCategory &&
      !this.props.computedMatch.params.hotDeal
        ? `${this.props.computedMatch.params.vehicleCategory}/`
        : '') +
      (this.props.computedMatch.params.vehicleType
        ? `${this.props.computedMatch.params.vehicleType}/`
        : 'carros/') +
      (this.props.computedMatch.params.filters
        ? this.props.computedMatch.params.filters
        : '') +
      (this.props.history.location.search
        ? this.props.history.location.search
        : '')
    if (
      this.props.computedMatch.params.vehicleCategory &&
      this.props.categories.fetched &&
      (!this.props.history.location.search ||
        !this.props.history.location.search
          .toLowerCase()
          .includes('necessidade='))
    ) {
      const _object = this.props.categories.result.find(
        x => x.Url == this.props.computedMatch.params.vehicleCategory
      )
      if (_object && _object.NomeCategoria) {
        url += this.props.history.location.search.includes('?') ? '&' : '?'
        url += `necessidade=${_object.NomeCategoria}`
      }
    }
    if (
      this.props.computedMatch.params.hotDeal &&
      this.props.hotDeal.fetched &&
      (!this.props.history.location.search ||
        !this.props.history.location.search.toLowerCase().includes('feirao='))
    ) {
      const { hotDeal } = this.props
      const _object =
        Array.isArray(hotDeal.result) &&
        hotDeal.result.find(
          x => x.URL == this.props.computedMatch.params.hotDeal
        )
      if (_object && _object.Name) {
        url += this.props.history.location.search.includes('?') ? '&' : '?'
        url += `feirao=${_object.Name}`
      }
    }
    if (url && url.includes('idcmpint')) {
      url = removeQueryParameter(url, 'idcmpint', true)
    }
    return url
  }

  getFilterSelected(filters) {
    if (filters) {
      filters = getFilterSelected(filters)
      if (JSON.stringify(filters) != JSON.stringify(this.state.listFilters)) {
        this.setState({ listFilters: filters })
      }
    }
  }

  handleOrderChange(order) {
    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.TRACKING_FROM
    )

    let searchURL = this.getSearchURL()
    if (!searchURL.includes('?'))  searchURL = `${searchURL}?`

    searchURL = searchURL.split('?')

    searchURL[1] = removeQueryParameter(searchURL[1], 'o', true)
    searchURL[1] = insertQueryParameter(searchURL[1], 'o', order)
    const newOrderUrl = `/${searchURL.join('?')}`
    this.props.history.push(newOrderUrl)

    if (isCookieCategoryActive) {
      setEventToLazyDispatch('ordenacaoRealizada')
    }
  }

  pushOrderChange(order) {
    this.setState({
      searchResult: undefined,
      actualPage: 1,
      quantityScrollAd: 120,
      newSearch: false,
      adsCount: 0,
    })
  }

  getOrderValue() {
    return getQueryParameter(this.props.location.search, 'o')
      ? getQueryParameter(this.props.location.search, 'o')
      : config.orderfilter
  }

  clickMoreAd() {
    this.setState(
      prevState => ({
        quantityScrollAd: prevState.quantityScrollAd + 120,
        newSearch: false,
      }),
      this.loadMoreItems()
    )
  }

  getCardPreferences() {
    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.CARD_PREFERENCES
    )

    if (isCookieCategoryActive) {
      const cardPreferences = getCookie(COOKIES.CARD_PREFERENCES)

      if (cardPreferences) {
        return JSON.parse(cardPreferences)
      }
      clearCookie(COOKIES.CARD_PREFERENCES)
    }

    return TYPE_RESULT_LIST.GRID.ID
  }

  setCardPreferences() {
    const { cardPreferences } = this.state
    const { cookies } = this.props.cookieNoticeContext
    const isActive = cookieCategoryIsActive(cookies, COOKIES.CARD_PREFERENCES)

    const preference =
      cardPreferences === TYPE_RESULT_LIST.GRID.ID
        ? TYPE_RESULT_LIST.LIST.ID
        : TYPE_RESULT_LIST.GRID.ID

    if (isActive) {
      setCookie(COOKIES.CARD_PREFERENCES, JSON.stringify(preference))
    }

    this.setState({ cardPreferences: preference }, () => {
      this.resetSearch()
    })

    if (onClientSide()){
      const cardDisplay = preference === '1' ? 'LadoaLadoRB' : 'ListaRB'
      sendDispatchEvent(`Exibir${cardDisplay}`)
    }
  }

  getSearchState(vehicleState) {
    let _result = 'Novo-Usado'
    if (vehicleState.includes('nov')) _result = 'Novo'
    else if (vehicleState.includes('usad')) _result = 'Usado'
    return _result
  }

  getObjDataLayer(eventType) {
    if (onClientSide()) {
      const { cookies } = this.props.cookieNoticeContext
      const isCookieCategoryActive = cookieCategoryIsActive(
        cookies,
        COOKIES.SEARCH_DATALAYER
      )
      const query = window.location.search

      const dataLayerCategories = []
      let _positionCategory
      let proposalCookieParsed
      const proposalCookie =
        this.cookiesState.formData && getEncryptedCookie(COOKIES.FORM_DATA)

      if (proposalCookie) {
        proposalCookieParsed = proposalCookie.Principal
      }

      if (
        this &&
        this.props.categories.result &&
        this.props.categories &&
        this.props.categories.fetched
      ) {
        if (this.props.searchResult.result.Count == 0)
          this.props.categories.result.map((value, key) => {
            dataLayerCategories.push(`${key}:${value.Categoria}`)
          })
        if (this.state.categoryStyling)
          this.props.categories.result.map((value, key) => {
            if (value.Categoria == this.state.categoryStyling.Categoria) {
              _positionCategory = key
            }
          })
      }

      const { filters, vehicleType } = this.state
      const { locationState, locationCity } = getItemFormattedLocation(
        filters.estadocidade
      )
      const orderValue = this.getOrderValue()

      const currentOrdenation = config.ordinations.find(
        ordernation => ordernation.value === parseInt(orderValue)
      )

      const { cardPreferences, searchResult, actualPage, adsCount } = this.state

      const preference =
        cardPreferences === TYPE_RESULT_LIST.GRID.ID
          ? TYPE_RESULT_LIST.GRID
          : TYPE_RESULT_LIST.LIST
      const objSearch = {
        location: {
          city: locationCity,
          state: locationState,
        },
        ordination: {
          name: currentOrdenation?.name,
          id: currentOrdenation?.value,
        },
        pageNumber: actualPage,
        totalResults: adsCount,
        vehicle: {
          type: {
            id: vehicleType === VEHICLE_TYPE.car ? 1 : 2,
            name: vehicleType === 'car' ? 'carro' : 'moto',
          },
        },
        cardExhibition: {
          id: preference.ID,
          name: preference.DESCRIPTION,
        },
        eventType,
      }

      const { detail, dealerInfo } = this.props

      const valuesFeirao = detail.HotDeal
        ? detail.HotDeal.filter(({ Id }) => +Id === FAIR.megaFair.id)
        : []

      clearCookie(COOKIES.SEARCH_DATALAYER)

      if (isCookieCategoryActive) {
        setCookie(
          COOKIES.SEARCH_DATALAYER,
          JSON.stringify({ search: objSearch }),
          0,
          15
        )
      }

      const { userIsAuth } = this.props
      const user = {
        loginStatus: userIsAuth ? 1 : 2,
      }

      const page = {
        url: window.location.href,
        trackingCode: {
          idcmp: getQueryParameter(query, 'idcmp'),
          idcmpint: getQueryParameter(query, 'idcmpint'),
          icid: getQueryParameter(query, 'icid'),
          lkid: getQueryParameter(query, 'lkid'),
        },
      }

      if (paginationExperience) {
         page.pageNumberRB = "2" 
       }

      const site = {
        brandOrigin: getQueryParameter(query, 'origem') || 'webmotors',
      }

      const obj = {
        site,
        user,
        page,
        search: createSearchObject(objSearch),
        dealer: createDealerObject(detail, dealerInfo, valuesFeirao),
        listItens: createListItensObject(searchResult),
        filter: {
          ad: {
            superPreco: this.props.newFilters.superPreco ? 1 : '',
            carDelivery: this.props.newFilters.carDelivery ? 1 : '',
            trocaTroco: this.props.newFilters.trocaComTroco ? 1 : '',
            vistoriado: this.props.newFilters.vistoriado ? 1 : '',
            visao360: this.props.newFilters['visão360°'] ? 1 : '',
          },
        },
      }

      const trackingData = createTrackingData(
        eventType,
        DATALAYER_PAGES.searchResult,
        obj
      )

      if(eventType === "customPageView"){
        if(this.state.disparoTrackingCarregamentoInicial === true){
          return false
        }
        this.setState({ disparoTrackingCarregamentoInicial: true })
      }
      this.dispatchAnalyticsEvent(trackingData)
    }
  }

  handleVehicleZeroKmPosition(i) {
    if (i % 10 == 0) {
      return true
    }
    return false
  }

  handleZeroStock() {
    this.setState({ fetchWbZeroKm: false })
  }

  checkPushMedia(_arrayCard = [], _result = []) {
    const { dealerInfo, location } = this.props
    const { cardPreferences } = this.state
    const idrevendedor = getQueryParameter(location.search, 'idrevendedor')

    if (
      this.checkCustomizationActive() ||
      (idrevendedor &&
        (!dealerInfo.fetched ||
          (dealerInfo.fetched &&
            dealerInfo.requested &&
            dealerInfo.requested.Id != idrevendedor) ||
          (idrevendedor &&
            dealerInfo &&
            dealerInfo.result &&
            dealerInfo.result &&
            dealerInfo.result.shield)))
    ) {
      return 0
    }

    const cardInterval = cardPreferences == TYPE_RESULT_LIST.LIST.ID ? 6 : 8 // de quantos em quantos cards vai inserir uma mídia
    const cardLimit = 10 // limite de mídias
    if (_result.length <= cardInterval && _arrayCard.length == _result.length) {
      return 1 //  insere um card por último caso tenha menos cards que o intervalo
    }
    const cardPosition = (_arrayCard.length + 1) / (cardInterval + 1)
    if (
      _result.length > cardInterval &&
      cardPosition == parseInt(cardPosition) &&
      parseInt(cardPosition) <= cardLimit
    ) {
      return cardPosition
    }
    return 0
  }

  renderCards() {
    const _arrayCard = []
    const { vehicleType } = this.state
    const { fairs } = this.props
    let wbZeroKmPosition = 0
    this.state.searchResult.map((vehicle, index) => {
      const _position =
        this.state.itemsPosition && this.state.itemsPosition.array
          ? this.state.itemsPosition.array.find(obj => {
              if (obj.Id == vehicle.UniqueId) {
                return obj.Position
              }
            })
          : undefined

      let _extraParam = [
        `pos=${_position ? _position.Position : undefined}`,
        ...[this.state.storeStyling ? 'bld=1' : undefined],
        `np=${this.state.actualPage}`,
        ...[
          this.state.hotDealStyling
            ? `hd=${encodeURIComponent(this.state.hotDealStyling.NomeHotDeal)}`
            : undefined,
        ],
        ...[
          this.state.originLojas
            ? `orilojas=${this.state.originLojas.KEY}`
            : undefined,
        ],
        ...[
          this.state.categoryStyling
            ? `ct=${this.state.categoryStyling.Categoria}`
            : undefined,
        ],
      ]
      _extraParam = _extraParam
        .filter(item => {
          return item != undefined
        })
        .join('&')

      const _linkCard = `${createUrlAd(
        vehicle,
        vehicleType,
        _extraParam,
        this.props.computedMatch && this.props.computedMatch.params
          ? this.props.computedMatch.params.hotDeal
          : undefined
      )}`

      if (
        this.handleVehicleZeroKmPosition(index) &&
        onClientSide() &&
        window.wbZeroKm
      ) {
        const { vehicles, cardType } = window.wbZeroKm

        if (vehicles && vehicles.length > 0 && vehicles[wbZeroKmPosition]) {
          _arrayCard.push(
            <GridItem key={`vehicle-zero-${index}`}>
              <VehicleCardNewCar
                image={vehicles[wbZeroKmPosition].image}
                name={vehicles[wbZeroKmPosition].name}
                version={vehicles[wbZeroKmPosition].version}
                year={vehicles[wbZeroKmPosition].year}
                price={vehicles[wbZeroKmPosition].price}
                href={vehicles[wbZeroKmPosition].url}
                isHorizontal={
                  this.state.cardPreferences == TYPE_RESULT_LIST.LIST.ID
                }
                experience={cardType}
              />
            </GridItem>
          )
        }

        wbZeroKmPosition = wbZeroKmPosition >= 2 ? 0 : wbZeroKmPosition + 1
      }

      const hasTestABCard = hasNewCardLayout()

      const props = handleSearchData({ searchResult: vehicle, href: _linkCard, fairs, vehicleType })

      _arrayCard.push(
        <GridItem data-qa={`vehicle_card_${index + 1}`} key={ !props.mediaZeroKm  ? props.id : 'media_' + props.versionId}>
          {hasTestABCard ? (
            <VehicleCardFactoryTestABCard
            isHorizontal={this.state.cardPreferences == TYPE_RESULT_LIST.LIST.ID}
              {...props}
              color={props.color}
              oldAd={vehicle}
            />)
            :
            <VehicleCardFactory
              isHorizontal={this.state.cardPreferences == TYPE_RESULT_LIST.LIST.ID}
              {...props}
              oldAd={vehicle}
              positionIndex={index}
            />
          }
        </GridItem>
      )
      const pushMedia = this.checkPushMedia(_arrayCard, this.state.searchResult)
      const formatedPushMedia = pushMedia >= 10 || this.state.cardPreferences != 1 ? pushMedia : `0${pushMedia}`
      const adMediaFormat =
        this.state.cardPreferences == 1
          ? `ad-search-result-${formatedPushMedia}`
          : `superbanner_${formatedPushMedia}`

      if (pushMedia) {
        _arrayCard.push(
          <AdPlacement
            key={adMediaFormat}
            id={adMediaFormat}
            style={`${
              this.state.cardPreferences == 1
                ? 'publift-media-short'
                : 'publift-media-wide'
            }`}
          />
        )
      }
    })

    const hasTestABCard = hasNewCardLayout()

    const cardDimensions = hasTestABCard ?
                           { width: '316px', height: '470px' } :
                           { width: '258px', height: '430px' };

    const { cardPreferences } = this.state;
    const gridIsHorizontal = cardPreferences === TYPE_RESULT_LIST.LIST.ID;

    const cardWidth = gridIsHorizontal ? '100%' : cardDimensions.width;
    const cardHeight = gridIsHorizontal ? '197px' : cardDimensions.height;

    return (
      <Grid
        gridIsHorizontal={gridIsHorizontal}
        cardWidth={cardWidth}
        cardHeight={cardHeight}
      >
        {_arrayCard}
        <span ref="lastItem" style={{ visibility: 'hidden' }} />
      </Grid>
    )
  }

  renderCardsPlaceHolder() {
    const { cardPreferences } = this.state
    const listCardPlaceHolder = []

    const hasTestABCard = hasNewCardLayout()
    const WhiteBoxReplaced = hasTestABCard ? WhiteBoxTestAbCard : WhiteBox
    const classNameReplaced = hasTestABCard ? 'WhiteBoxTestAbCard' : 'WhiteBox'

    for (let index = 0; index < 24; index++) {
      listCardPlaceHolder.push(
        <WhiteBoxReplaced
          key={index + 1}
          className={`${classNameReplaced}--card-vehicle ${
            cardPreferences == TYPE_RESULT_LIST.LIST.ID
              ? `${classNameReplaced}--card-vehicle-grid`
              : ''
          }`}
        >
          {cardPreferences == TYPE_RESULT_LIST.LIST.ID ? (
            <CardVehicleListPlaceholder />
          ) : (
            <CardVehiclePlaceholder />
          )}
        </WhiteBoxReplaced>
      )
    }
    return (
      <div
        className={`ContainerCardVehicle  ${
          cardPreferences == TYPE_RESULT_LIST.LIST.ID
            ? 'ContainerCardVehicle--grid'
            : ''
        }`}
      >
        {listCardPlaceHolder}
      </div>
    )
  }

  getParamFilterResult() {
    if (this.state.listFilters) {
      const param = {
        openFilter: this.toggleFilter.bind(this),
        listFilters: this.state.listFilters,
        value: this.getOrderValue(),
        renderClickOrderSelected: this.handleOrderChange,
        setCardPreferences: this.setCardPreferences,
      }
      return param
    }
    return undefined
  }

  checkCookieProposal() {
    const _cookieSendProposal =
      this.cookiesState.formData && getEncryptedCookie(COOKIES.FORM_DATA)
    if (_cookieSendProposal) {
      this.setState({ cookieSendProposal: _cookieSendProposal })
    }
  }

  sendProposal() {
    const _data = this.state.cookieSendProposal
    _data.Mensagem = MESSAGE_LEAD.ONE
    _data.FBCLID = getFBCLIDFromUrl(this.props.location.search)
    _data.GCLID = getGCLIDFromUrl(this.props.location.search)
    if (_data) {
      this.props.dispatch(fetchProposal(_data))
    }
  }

  seePhone(uniqueId) {
    const _data = {
      vehicleType: this.state.vehicleType,
      idAnuncio: uniqueId,
    }
    const { SellerType = '' } = this.props.searchResult.result.SearchResults[0].Seller || {};
    this.props.dispatch(fetchPhonesDetail(_data, SellerType)).then(() => {})
    return undefined
  }

  renderResultZero() {
    if (this.state.listCardPlaceHolder) {
      return this.placeholder
    }
    const _locationLeft = getCookieLocationLeft()
    const _locationRight = getCookieLocationRight()

    return (
      <div className="ResultZero">
        {this.state.breadCrumb && (
          <BreadCrumb breadCrumb={this.state.breadCrumb} />
        )}
        <div className="ResultZero__header">
          {this.state.vehicleType == VEHICLE_TYPE.bike ? (
            <h1 role="heading" aria-level={1}>Ops, não encontramos nenhuma moto como esta!</h1>
          ) : (
            <Fragment>
              <h1 role="heading" aria-level={1}>Ops, não encontramos nenhum carro como este! </h1>
              <p>Mas aproveite e veja algumas recomendações para você:</p>
            </Fragment>
          )}
        </div>
        <div className="ResultZero__container">
          <RecommendedVehicles
            title={
              this.props.recommendedVehicles &&
              this.props.recommendedVehicles.fetched &&
              this.props.recommendedVehicles.result ? (
                'Recomendados para você'
              ) : (
                <PlaceHolder width="px" px="100" />
              )
            }
            vehicleType={this.state.vehicleType}
            estadocidade={_locationLeft}
            filtersOpen={this.state.filtersOpen}
            origin={ORIGIN_PAGES.BUSCA.KEY}
            recommendationTimestamp={this.state.recommendationTimestamp}
          />

          <Categories
            id="categories-carousel"
            origin={ORIGIN_PAGES.BUSCA.KEY}
          />

          {this.state.vehicleType == VEHICLE_TYPE.bike ? undefined : (
            <BestSeller
              source={
                this.state.vehicleType == 'car'
                  ? this.props.bestSellers.result
                  : []
              }
              locationLeft={_locationLeft}
              locationRight={_locationRight}
              title={
                this.props.bestSellers.fetched &&
                this.props.bestSellers.result ? (
                  'Carros mais buscados'
                ) : (
                  <PlaceHolder width="px" px="100" />
                )
              }
              id="CarouselMostWanted"
            />
          )}
        </div>
      </div>
    )
  }

  handlePageStyling() {
    if (this.state.storeStyling) {
      if (
        typeof document !== 'undefined' &&
        this.state.sellerImgExists &&
        this.state.sellerImgExists.id != this.state.filters.idrevendedor
      ) {
        imageExists(
          this.state.storeStyling.BannerDesktop,
          () => {
            this.setState({
              sellerImgExists: {
                exists: true,
                id: this.state.filters.idrevendedor,
              },
            })
          },
          () => {
            this.setState({
              sellerImgExists: {
                exists: false,
                id: this.state.filters.idrevendedor,
              },
            })
          }
        )
      }
      return {
        pageStyle: {},
        bannerImg: this.state.sellerImgExists.exists
          ? this.state.storeStyling.BannerDesktop
          : `/assets/img/webp/blindagem/desk-results-noimg.webp?t=${config.randomUrl}`,
        bannerClass: 'Media--store',
        bannerColor: this.state.storeStyling.CorPrimaria,
        title: undefined,
      }
    }
    if (this.state.categoryStyling && !this.state.filters.idrevendedor) {
      return {
        pageStyle: {
          background: `linear-gradient(180deg, ${this.state.categoryStyling.CorPrimaria} 0px,${this.state.categoryStyling.CorPrimaria} 420px,${this.state.colorBackgroundDefault} 1120px) 0px 0px`,
        },
        bannerImg: this.state.categoryStyling.BannerDesktop,
        bannerClass: 'Media--category',
        bannerColor: this.state.categoryStyling.CorPrimaria,
        title: (
          <strong className="title-styling">
            {this.state.categoryStyling.Nome}
          </strong>
        ),
        link: this.state.categoryStyling.LinkBanner,
      }
    }
    if (this.state.hotDealStyling && !this.state.filters.idrevendedor) {
      return {
        pageStyle: {},
        bannerImg: this.state.hotDealStyling.BannerDesktop,
        bannerClass: 'Media--store',
        bannerColor: this.state.hotDealStyling.CorPrimaria,
        title: this.state.hotDealStyling.Regulation ? (
          <div className="Media__hotdeal-container">
            <a
              className="Media__hotdeal-container__regulation"
              href={this.state.hotDealStyling.Regulation}
              target="_blank"
            >
              Regulamento
            </a>
          </div>
        ) : (
          ''
        ),
      }
    }
    if (this.state.makeModelStyling && !this.state.filters.idrevendedor) {
      return {
        pageStyle: {},
        bannerImg: this.state.makeModelStyling.BannerDesktop,
        bannerClass: `Media--makeModel${
          this.state.makeModelStyling.DarkText
            ? ' Media--makeModel--darkText'
            : ''
        }`,
        bannerColor: this.state.makeModelStyling.CorPrimaria,
        link: this.state.makeModelStyling.LinkBanner,
        title: (
          <strong className="title-styling">
            {this.state.makeModelStyling.Nome}
          </strong>
        ),
      }
    }
    return {
      pageStyle: undefined,
      bannerImg: '',
      bannerClass: 'Media--not-category',
      bannerColor: undefined,
      title: undefined,
    }
  }

  getCurrentMakeModel(makeOnly) {
    if (
      this.props.searchResult.result &&
      this.props.searchResult.result.FilterCustom &&
      this.props.searchResult.result.FilterCustom.Veiculos &&
      this.props.searchResult.result.FilterCustom.Veiculos[0] &&
      this.props.searchResult.result.FilterCustom.Veiculos[0].Marca
    ) {
      return (
        this.props.searchResult.result.FilterCustom.Veiculos[0].Marca +
        (!makeOnly &&
        this.props.searchResult.result.FilterCustom.Veiculos[0].Modelo
          ? ` ${this.props.searchResult.result.FilterCustom.Veiculos[0].Modelo}`
          : '')
      )
    }
    return ''
  }

  renderHelmet() {
    return (
      <Fragment>
        <Helmet>
          {this.state.title ? <title>{this.state.title}</title> : ''}
          <meta name="language" content="pt-br" />
          {this.state.description ? (
            <meta name="description" content={this.state.description} />
          ) : (
            ''
          )}
          <meta property="og:url" content={this.props.location.href} />
          <link rel="canonical" href={this.state.canonical || ''} />
          <link rel="alternate" hreflang="pt-BR" href={this.state.canonical || ''} />
        </Helmet>
      </Fragment>
    )
  }

  renderSearchResults() {
    const { adPlacement, listCardPlaceHolder } = this.state
    const hasTestABCard = hasNewCardLayout()

    const skyScrapperState = adPlacement.busca_skyscrapper
    const adsCardsStyle = {
      width: 'calc(100% - 160px)',
    }

    const adsVerticalStyle = {
      display: `block`,
      height: '0px'
    }

    const adsStyle = {
      width:
        skyScrapperState && skyScrapperState.size
          ? `calc(100% - 160px)`
          : '0px',
    }

    if (
      listCardPlaceHolder ||
      (this.props.searchResult.fetched &&
        this.props.searchResult.result &&
        this.props.searchResult.result.Count > 0)
    ) {

      const { Pagination: { PageTotal } = 0 } = this.props?.searchResult?.result || {};

      return (
        <Fragment>
          {this.state.breadCrumb && !this.state.hotDealStyling && (
            <BreadCrumb breadCrumb={this.state.breadCrumb} />
          )}
          {this.checkCustomizationActive() &&
          !this.state.makeModelStyling ? undefined : (
            <h1 data-qa="filter_title" className="title-search">
              {listCardPlaceHolder ||
              this.state.isLocationLoading ||
              !this.state.searchResult ? (
                <PlaceHolder width="px" px="350" />
              ) : (
                this.state.h1
              )}
            </h1>
          )}
          {!this.state.categoryStyling &&
          this.state.cardPreferences == TYPE_RESULT_LIST.LIST.ID ? (
            <FoundCars
              placeholder={
                listCardPlaceHolder ||
                this.state.isLocationLoading ||
                !this.state.searchResult
              }
              adsCount={this.state.adsCount}
              vehicleType={this.state.vehicleType}
            />
          ) : (
            <FoundCars
              customization={
                this.checkCustomizationActive() &&
                !this.state.makeModelStyling &&
                !this.state.hotDealStyling
              }
              placeholder={
                this.state.listCardPlaceHolder ||
                this.state.isLocationLoading ||
                !this.state.searchResult
              }
              variation={this.state.categoryStyling ? 'category' : null}
              adsCount={this.state.adsCount}
              vehicleType={this.state.vehicleType}
            />
          )}
          {!this.state.searchResult ||
          listCardPlaceHolder ||
          this.state.fetchWbZeroKm ||
          this.state.isABTestLoading ||
          this.state.isLocationLoading ? (
            this.placeholder
          ) : (
            <StickyContainer className="sticky_container">
              <div
                data-qa="vehicle_list_container"
                className={`ContainerCardVehicle ${
                  skyScrapperState ? 'ads_align' : ''
                } ${
                  this.state.cardPreferences == TYPE_RESULT_LIST.LIST.ID
                    ? 'ContainerCardVehicle--grid'
                    : ''
                }`}
                ref="listAdScrollInfinity"
                key={
                  this.state.cardPreferences == TYPE_RESULT_LIST.LIST.ID
                    ? 'wideMediaList'
                    : 'cardMediaList'
                }
              >
                <div style={adsCardsStyle}>{this.renderCards()}</div>
                {!this.checkCustomizationActive() && (
                  <Sticky
                    className="visible_controller"
                    topOffset={-123}
                    disableCompensation
                  >
                    {({ isSticky }) => (
                      <div className="ads_vertical" style={adsVerticalStyle}>
                        <div
                          style={adsStyle}
                          className={`content-media ${
                            isSticky ? 'fixed' : 'fixed-withTopSpace'
                          }`}
                        >
                          <AdPlacement
                            id="busca_skyscrapper"
                            style={`Prebid-skyscrapper ${
                              hasTestABCard ? 'test-ab-prebid' : ''
                            }`}
                            onLoadAds={this.handleLoadAds}
                          />
                        </div>
                      </div>
                    )}
                  </Sticky>
                )}
              </div>
            </StickyContainer>
          )}
          <div className="ContainerButtons">
            {!paginationExperience && (
              <>
                {this.state.loadMore ? (
                  <div className="ContainerButtons__loading-search">
                    <img
                      className="ContainerButtons__loading-search__loading-busca"
                      src="/assets/img/loading-busca.gif"
                      width={80}
                      height={80}
                      alt="Carregando"
                    />
                    <p>
                      Estamos carregando <br /> mais{' '}
                      {this.state.vehicleType == VEHICLE_TYPE.bike
                        ? VEHICLE_TYPE.BIKE
                        : VEHICLE_TYPE.CAR}
                    </p>
                  </div>
                ) : undefined}
                {this.state.newSearch ? (
                  <div className="ContainerButtons__details">
                    {this.state.enabledMoreItems ? (
                      <Fragment>
                        <strong className="ContainerButtons__details__not-find-seach">
                          Não achou o que buscava?
                        </strong>
                        <div className="ContainerButtons__details__buttons">
                          <Button
                            name={this.state.vehicleType}
                            id="ButtonCarriesMoreCars"
                            value={this.state.actualPage}
                            className=" Button--more-items"
                            type="submit"
                            onClick={this.clickMoreAd.bind(this)}
                          >
                            Carregar mais
                          </Button>
                        </div>
                      </Fragment>
                    ) : undefined}
                  </div>
                ) : undefined}
              </>
            )}

            {paginationExperience && (
              <div className="ContainerButtons">
                <Pagination
                  className="pagination"
                  pagesCount={PageTotal}
                  currentPage={this.state.actualPage}
                  onPageChange={this.handlePageChange}
                  variant="compound"
                  dataQA="search-pagination" PageCurrent
                />
              </div>
            )}
          </div>
        </Fragment>
      )
    }
    return this.renderResultZero()
  }

  checkCustomizationActive() {
    const { categoryStyling, storeStyling, hotDealStyling, makeModelStyling } =
      this.state
    return !!(
      categoryStyling ||
      storeStyling ||
      hotDealStyling ||
      makeModelStyling
    )
  }

  searchLoad = () => {
    this.setState({ listCardPlaceHolder: true })
  }

  handleNewFilterChange = data => {
    const { SearchResults } = data
    this.setState({
      searchResult: SearchResults,
      listCardPlaceHolder: false,
    })
    sendDispatchEvent('filtroRealizado')
  }

  handleLocationLoading(isLocationLoading = false) {
    this.setState({ isLocationLoading })
  }

  getLocationSearchResultByVehicleType() {
    const { filtersCarLocation, filtersBikeLocation } = this.props
    const vehicleType = this.state.vehicleType.toString().toLowerCase()
    const isCar = vehicleType === VEHICLE_TYPE.car
    const fetchResult = isCar ? filtersCarLocation : filtersBikeLocation

    return parseLocationObj(fetchResult.result, [])
  }

  geolocationService(cookies) {
    const updateGeolocationCookieParsed = (cookieParsed, stateMatch) => {
      const cookie = {
        ...cookieParsed,
        estadocidade: stateMatch.name,
      }

      cookie.localizacao && delete cookie.localizacao

      return cookie
    }

    const findStateMatch = (regionName, locations) => {
      return locations.find(
        location =>
          removeAccents(location.name.toLowerCase().trim()) === regionName
      )
    }

    const checkGeolocationResult = geolocationCookieParsed => {
      const { geolocation, history } = this.props

      const {
        result: { response },
      } = geolocation

      if (!response || !response['edge-region']) {
        this.handleLocationLoading()
        return false
      }

      const stateName = removeAccents(
        returnStateLong(response['edge-region']).toLowerCase()
      )

      const locations = this.getLocationSearchResultByVehicleType()

      if (!locations || locations.length === 0){
        this.handleLocationLoading()
        return false
      }

      const stateMatch = findStateMatch(stateName, locations)

      if (!stateMatch || !stateMatch.name) {
        this.handleLocationLoading()
        return false
      }

      if(!checkStateIsAllowedList(stateMatch.name)){
        this.handleLocationLoading()
        return false
      }

      try {
        const updatedCookie = updateGeolocationCookieParsed(
          geolocationCookieParsed,
          stateMatch
        )

        if (updatedCookie) {
          setCookie(COOKIES.GEOLOCATION, JSON.stringify(updatedCookie))

          const { estadocidade: filterLocation = '' } = this.state.filters || {}

          if (filterLocation !== '' && filterLocation !== 'estoque') {
            this.handleLocationLoading()
            return false
          }
          const currentUrl = window.location.href;
          const hasFilterLocationInURL = hasLocationInUrl(currentUrl)
          const hasForcedLocation = window.sessionStorage.getItem(
            'shouldNotForceLocation'
          )

          if (hasFilterLocationInURL || hasForcedLocation){
            this.handleLocationLoading()
            return false
          }

          const searchParams = new URLSearchParams(document.location.search)
          searchParams.set('estadocidade', stateMatch.name)
          let customParams = ''

          customParams = Array.from(searchParams).reduce(
            (acc, [key, value], index) => {
              const prefix = index > 0 ? '&' : ''
              return `${acc}${prefix}${encodeURIComponent(
                key
              )}=${encodeURIComponent(value)}`
            },
            ''
          )

          history.push({ search: customParams })
          this.setState({
            estadocidade: stateMatch.name,
            locationValue: stateMatch.name,
            searchResult: undefined,
            isLocationLoading: false,
          })
          sessionStorage.setItem('filterLocationApplyByIP', true)
        }
        this.handleLocationLoading()
      } catch (e) {
        this.handleLocationLoading()
      }
    }

    const fetchAndProcessGeolocation = geolocationCookieParsed => {
      if (this.props.geolocation &&
        (this.props.geolocation.isPending || this.props.geolocation.error)
      ){
        this.handleLocationLoading()
        return false
      }

      if (this.props.geolocation && this.props.geolocation.fetched) {
        checkGeolocationResult(geolocationCookieParsed)
      } else {
        this.props
          .dispatch(fetchGeolocation())
          .then(() => {
            if (this.props.geolocation.error) {
              this.handleLocationLoading()
              return false
            }
            checkGeolocationResult(geolocationCookieParsed)
          })
          .catch(() => {
            this.handleLocationLoading()
          })
      }
    }

    const handleUserNotPermittedUseGeolocation = geolocationCookieParsed => {

      //verificar se a url ja possui um filtro de localizacao
      const currentUrl = window.location.href;
      if (hasLocationInUrl(currentUrl)){        
        this.handleLocationLoading()
        return false
      }
      sessionStorage.removeItem('latLongFilterApplied')
      fetchAndProcessGeolocation(geolocationCookieParsed)
    }

    const handleGeolocationPermission = geolocationCookieParsed => {
      if (!navigator.geolocation) {
        handleUserNotPermittedUseGeolocation(geolocationCookieParsed)
        return
      }

      navigator.permissions.query({ name: 'geolocation' }).then(result => {
        sessionStorage.setItem('geolocationPermissionType', result.state)
        switch (result.state) {
          case 'prompt':
          case 'denied':
            handleUserNotPermittedUseGeolocation(geolocationCookieParsed)
            break
          default:
            this.handleLocationLoading()
            break
        }
      })
    }

    const fetchLocationSearch = (vehicleType) => {
      return new Promise((resolve, reject) => {
        const {filtersCarLocation, filtersBikeLocation} = this.props
        const isCar = vehicleType === VEHICLE_TYPE.car
        const fetchName = isCar ? fetchFiltersCarLocation : fetchFiltersBikeLocation
        const fetchResult = isCar ? filtersCarLocation : filtersBikeLocation

        if (!fetchResult.fetched && !fetchResult.isPending) {
          this.props
            .dispatch(fetchName(config.urlApp))
            .then((response) => {
              resolve(response);
            })
            .catch(() => {
              reject(false)
            })
        } else {
          reject(false)
        }
      })
    }

    this.setState({ fetchLocationSearch })

    const getUserLocation = () => {
      if (!cookies || !cookieCategoryIsActive(cookies, COOKIES.GEOLOCATION)) {
        this.handleLocationLoading()
        return false
      }

      const geolocationCookie = getCookie(COOKIES.GEOLOCATION)
      let geolocationCookieParsed
      try {
        geolocationCookieParsed = JSON.parse(geolocationCookie)
      } catch (e) {
        geolocationCookieParsed = {
          estadocidade: '',
        }
      }

      handleGeolocationPermission(geolocationCookieParsed)
    }

    const vehicleType = this.state.vehicleType.toString().toLowerCase()

    fetchLocationSearch(vehicleType).then(() => {
      getUserLocation()
    })
    .catch(() => {
      this.handleLocationLoading()
    })
  }

  isUnavailable() {
    const { searchResult } = this.props

    return searchResult.result && searchResult.result.ExceededPlan
  }

  render() {
    const { bestSellers } = this.props
    const { vehicleType } = this.state
    const { hasBlackFair } = this.props.fairs
    const pageBlackFairClassName = getBlackFairClassName(hasBlackFair)

    const recommendedVehiclesBreakpoints = createResponsiveBreakpoints([
      {
        breakpoint: 1930,
        slidesToShow: 5,
      },
      {
        breakpoint: 1600,
        slidesToShow: 4,
      },
      {
        breakpoint: 1200,
        slidesToShow: 3,
      },
      {
        breakpoint: 990,
        slidesToShow: 2,
      },
    ])

    const categoriesBreakpoints = createResponsiveBreakpoints([
      {
        breakpoint: 1930,
        slidesToShow: 4,
      },
      {
        breakpoint: 1600,
        slidesToShow: 3,
      },
      {
        breakpoint: 1200,
        slidesToShow: 2,
      },
      {
        breakpoint: 880,
        slidesToShow: 1,
      },
    ])

    const bestSellersBreakpoints = createResponsiveBreakpoints([
      {
        breakpoint: 1600,
        slidesToShow: 5,
      },
      {
        breakpoint: 1400,
        slidesToShow: 4,
      },
      {
        breakpoint: 1160,
        slidesToShow: 3,
      },
      {
        breakpoint: 990,
        slidesToShow: 2,
      },
    ])

    if (this.state.error404) return <NotFound />
    const pageStyling = this.handlePageStyling()

    const isCar = vehicleType === 'car'

    const showBestSeller =
      isCar &&
      bestSellers.fetched &&
      bestSellers.result &&
      bestSellers.result.length > 0

    const _locationLeft = getCookieLocationLeft()
    const _locationRight = getCookieLocationRight()

    return (
      <Page
        openFooter={this.state.openFooter}
        headerBackLinkTo="/"
        vehicleType={this.state.vehicleType}
        enabledSearchBar
        getSearchResult={this.getSearchResult}
        enabledFilterResult
        paramFilterResult={this.getParamFilterResult()}
        url={this.props.location}
        history={this.props.history}
        fetchAutoComplete={this.fetchAutoComplete.bind(this)}
        key="SearchResult"
        pagename="SearchResult"
      >
        {this.renderHelmet()}
        <Main
          className={`page--search ${pageBlackFairClassName} ${
            !this.state.filtersOpen ? 'page--search--filters-closed' : ''
          } ${this.state.hotDealStyling ? 'page--search--hotDeal' : ''} `}
        >
          <div className="container">
            <div className="Search-result Search-result--filter-fixed">
              <FilterResult
                newFilters={this.props.newFilters}
                openFilter={this.toggleFilter.bind(this)}
                listFilters={this.state.listFilters}
                value={this.getOrderValue()}
                renderClickOrderSelected={this.handleOrderChange}
                setCardPreferences={this.setCardPreferences}
                cardPreferences={this.state.cardPreferences}
                vehicleType={this.state.vehicleType}
                closeBalloon={item => this.setState({ balloonFilters: item })}
                fetchAutoComplete={this.fetchAutoComplete.bind(this)}
                autoCompleteCar={this.props.autoCompleteCar}
                autoCompleteBike={this.props.autoCompleteBike}
                cookieNoticeContext={this.props.cookieNoticeContext}
                responsive={this.props.responsive.result}
              />
            </div>
            {this.checkCustomizationActive() ? (
              <Media
                id="BannerFilterResultA"
                img={pageStyling.bannerImg}
                target="_blank"
                className={pageStyling.bannerClass}
                onClick={this.handleMediaBannerClick.bind(this)}
                alt={
                  this.state.categoryStyling
                    ? this.state.categoryStyling.Nome
                    : this.state.makeModelStyling
                    ? this.state.makeModelStyling.Nome
                    : undefined
                }
                title={
                  this.state.categoryStyling
                    ? this.state.categoryStyling.Nome
                    : this.state.makeModelStyling
                    ? this.state.makeModelStyling.Nome
                    : undefined
                }
                customization={this.checkCustomizationActive()}
                href={pageStyling.link}
                callToAction={
                  !!this.state.makeModelStyling &&
                  this.state.makeModelStyling.CTA
                }
                bgColor={
                  !!this.state.makeModelStyling &&
                  this.state.makeModelStyling.bgColor
                }
              >
                {pageStyling.title}
              </Media>
            ) : undefined}
            <Filters
              key={`Filters-${this.state.locationValue}`}
              history={this.props.history}
              location={this.props.location}
              match={this.props.computedMatch}
              filtersOpen={this.state.filtersOpen}
              title="FILTRAR"
              closeCallback={this.toggleFilter.bind(this)}
              vehicleType={this.state.vehicleType}
              vehicleTypeCallback={undefined}
              initialFilters={this.state.lastSearchCookies}
              order={this.getOrderValue()}
              fetchingSearch={this.state.fetching}
              allFilters={this.state.allFilters}
              filterCustom={this.state.locationFilters}
              handleNewFilterChange={this.handleNewFilterChange}
              beginSearchLoad={this.searchLoad}
              locationSearchResult={this.getLocationSearchResultByVehicleType()}
              fetchLocationSearch={this.state.fetchLocationSearch}
            />
            <div className="Search-result Search-result--container-right">
              {this.isUnavailable() ? (
                <AdWarning>
                  <RecommendedVehicles
                    title="Recomendados para você"
                    customSettings={{
                      responsive: recommendedVehiclesBreakpoints,
                    }}
                    vehicleType={this.state.vehicleType}
                  />

                  <Categories
                    id="categories"
                    customSettings={{
                      slidesToShow: 5,
                      responsive: categoriesBreakpoints,
                    }}
                  />

                  {showBestSeller && (
                    <BestSeller
                      source={this.props.bestSellers.result}
                      locationLeft={_locationLeft}
                      locationRight={_locationRight}
                      title="Carros mais buscados"
                      id="mostWanted"
                      lastSearch={this.state.lastSearchCookies}
                      customSettings={{
                        slidesToShow: 6,
                        responsive: bestSellersBreakpoints,
                      }}
                    />
                  )}
                </AdWarning>
              ) : (
                this.renderSearchResults()
              )}
            </div>
          </div>

          <div className="openFooter-container">
            <Button
              dataQA="toggle_footer"
              name="ButtonOpenFooterFixed"
              id="ButtonOpenFooterFixed"
              value="ButtonOpenFooterFixed"
              className={`Button--open-footer ${
                this.state.openFooter ? '' : ' Button--close-footer'
              }`}
              type="submit"
              onClick={this.handleToggleFooter.bind(
                this,
                !this.state.openFooter
              )}
            >
              {this.state.openFooter
                ? 'Fechar'
                : 'Comprar, Vender, Serviços, Notícias WM1, Ajuda e Institucional'}
            </Button>
          </div>
        </Main>
      </Page>
    )
  }
}
export default withCookieNotice(
  connect(store => {
    return {
      searchResult: store.searchResultState,
      category: store.categoryState,
      categories: store.categoriesState,
      detail: store.detailState,
      dealerInfo: store.dealerInfoState,
      bestSellers: store.bestSellersState,
      recommendedVehicles: store.recommendedVehiclesState,
      autoCompleteCar: store.autoCompleteCarState,
      autoCompleteBike: store.autoCompleteBikeState,
      phonesDetail: store.phonesDetailState,
      proposal: store.proposalState,
      hotDeal: store.hotDealState,
      declareSeo: store.declareSeoState,
      newFilters: store.filters,
      userIsAuth: store.userIsAuth,
      fairs: store.fairs,
      responsive: store.responsiveState,
      geolocation: store.geolocationState,
      filtersCarLocation: store.filtersCarLocationState,
      filtersBikeLocation: store.filtersBikeLocationState,
    }
  })(withTracking(PageSearch))
)